import { jsx as _jsx } from "react/jsx-runtime";
import { Portal } from "@air/primitive-portal";
import { memo } from "react";
export const AnnotationTooltip = /*#__PURE__*/ memo((param)=>{
    let { innerRef, shouldDisplay, text } = param;
    return /*#__PURE__*/ _jsx(Portal, {
        children: shouldDisplay && /*#__PURE__*/ _jsx("div", {
            className: "fixed z-1 rounded-4 bg-black/80 px-2 py-1 transition-opacity",
            ref: innerRef,
            children: /*#__PURE__*/ _jsx("div", {
                className: "text-12 font-semibold text-white",
                children: text
            })
        })
    });
});
AnnotationTooltip.displayName = "AnnotationTooltip";
